import PocketBase from 'pocketbase';

function getUrl() {
  if (typeof window !== 'undefined' && window.POCKETBASE_URL) return window.POCKETBASE_URL;
  try {
    if (import.meta.env?.VITE_POCKETBASE_URL) return import.meta.env.VITE_POCKETBASE_URL;
  } catch (_) { /* Jest / ambienti senza import.meta */ }
  return 'http://127.0.0.1:8090';
}

const GLOBAL_KEY = '__fantapp_pocketbase_client__';

export function getPocketBase() {
  if (!globalThis[GLOBAL_KEY]) {
    globalThis[GLOBAL_KEY] = new PocketBase(getUrl());
    console.log('[POCKETBASE] client creato:', getUrl());
  }
  return globalThis[GLOBAL_KEY];
}

/** Verifica che l'istanza PocketBase risponda. */
export async function testPocketBaseConnection() {
  try {
    const pb = getPocketBase();
    await pb.health.check();
    return { success: true };
  } catch (error) {
    return { success: false, error: error?.message || String(error) };
  }
}

/** Escape valore stringa per i filtri PocketBase (`filter: 'campo="valore"'`). */
export const escFilter = (s) => String(s).replace(/"/g, '\\"');

export default getPocketBase;
